import {Avatar, Button, Checkbox, Input, Modal} from 'antd'
import {
    course_assignStudentToCourseClass_Api,
    course_getCourseClassesAvailForStudent_Api,
    course_getCourseClassStudents_Api,
    course_revokeStudentFromCourseClass_Api,
    course_transferStudentFromCourseClassTo_Api,
    medal_addMedalAward_Api,
} from 'apis'
import {getId, getType} from 'apis/model/base'
import classNames from 'classnames'
import FieldsFactory from 'components/form/FieldsFactory'
import FormActionBar from 'components/form/FormActionBar'
import {Formik, FormikConsumer} from 'formik'
import _ from 'lodash'
import useAsyncAction from 'modules/asyncCache/useAsyncAction'
import Translate from 'modules/local/Translate'
import useTranslate from 'modules/local/useTranslate'
import React, {useCallback, useContext, useMemo, useState} from 'react'
import {AiOutlineAudit} from 'react-icons/ai'
import {BiSolidEdit, BiTrash} from 'react-icons/bi'
import {RiMapPinFill, RiSearchEyeLine, RiUserShared2Line} from 'react-icons/ri'
import {compose, mapProps, pure} from 'recompose'
import {AppEntities} from 'views/AppLocals/enums'
import {NullAsDefault, pagerControls} from 'views/Shared'
import {StudentActionTypes} from '..'
import {course_assignMultiStudentToCourseClass_Api, course_editStudentFromCourseClass_Api} from '../../../../apis'
import DynamicFieldsUtilization from '../../../../components/DynamicFields/DynamicFieldUtilization'
import {createSelectValue, createValue} from '../../../../components/form/utils'
import HeaderGroupItem from '../../../../components/ItemLayout/HeaderGroupItem'
import {FullSideModalLayout} from '../../../../components/Modal/SideModalLayout'
import {createModalTitle} from '../../../../components/renderFunctions/createModalTitle'
import {renderIf, renderIfElse, renderSelf, shallowDiff} from '../../../Shared'
import {renderCourseClassStudent} from '../../../Workspace/Course/functions/renderCourseClassStudent'
import EntityList, {NoneStickyMeta} from '../../EntityList'
import {showDeleteConfirmDialog} from '../../factory/createConfirmDialog'
import createContextMenu from '../../factory/createContextMenu'
import {notifyOnError} from '../../factory/createErrorEvent'
import {NotificationActionTypes, successNotify,} from '../../factory/createNotification'
import {bindQueryParam, bindQueryParams} from '../../functions/routerHelper'
import {HeaderWithIconLine, ListHeaderLineAndDes} from '../../Templates/items/ListHeader'
import {CourseClassSelector} from '../components/CourseClassSelector'
import {StudentSelector} from '../components/StudentSelector'
import {CourseClassStudentAttendantsForm} from './CourseClassAttendanceForm'
import {createControlledFormField} from "../../factory/createFormField";
import LookupField from "../../../../components/LookupField";
import {SubClassTags} from "../components/SubClassTags";
import CourseClassContext from "../CourseClassContext";
import {LayoutContext} from "../../../../components/layouts/Default/LayoutContext";
import {MdChurch} from "react-icons/md";
import {StudentInformationFull} from "../Student/components/StudentInformationFull";
import {StudentInformationCompact} from "../Student/components/StudentInformationCompact";
import {BsCaretRightFill, BsInfoCircleFill} from "react-icons/bs";
import {ItemInformation} from "../../Organization/OrganizationEntity";
import getTitle from "../../../../helpers/getTitle";
import {GiCardExchange, GiPlainCircle} from "react-icons/gi";
import EmptyHolder from "../../../../components/EmptyHolder";
import {GoDash, GoDotFill} from "react-icons/go";
import WorkspaceContext from "../../../Workspace/WorkspaceContext";
import {FaUserGraduate} from "react-icons/fa6";
import {Link} from "react-router-dom";
import getLinkToDetail from "../../../../helpers/getLinkToDetail";
import Pure from "../../../../components/Pure";
import FieldDecorator from "../../../../components/form/FieldDecorator";
import getAliasName from "../../../../helpers/getAliasName";
import {ActionModalWrapper} from "../../../../components/form/ActionModalWrapper";
import LoadingBlock from "../../../LoadingBlock";
import withTranslate from "../../../../modules/local/withTranslate";
import {SelectWidget} from "../../custom/ReactSelectComponents";


const StudentInCourseSelection = ({form, name, value, defaultValue = [], handleChange = NullAsDefault, course, course_class, ...props}) => {
    const t = useTranslate()
    const {isSm} = useContext(LayoutContext)
    const students = value || defaultValue;
    const {organization} = useContext(WorkspaceContext)

    return (
        <div className="flex flex-col gap-3">
            <div className="flex">
                <LookupField
                    cacheRequired={false}
                    title={t('select student for the class')}
                    createIfNotExists={true}
                    placeholder={t('click to select / create')}
                    apiPath={`/lookup/student/get-by-types?owner_type=organization&owner_id=${organization?.id}&course_id=${course?.id}&not_course_class_id=${course_class?.id}`}
                    OptionWrapper={({children, ...props}) =>
                        <div className="flex items-center gap-2 border border-color-50 hover:shadow-md rounded-lg relative" {...props}>
                            {children}
                        </div>
                    }
                    renderOption={(o, i) => {
                        const {avatar, student_idcode, patron_saint_name, fullname, course_class_students = [], registered_subjects = []} = o ?? {}

                        return (
                            <div key={i} className="my-2 flex flex-col flex-1 gap-1">
                                <div className="flex items-center gap-2">
                                    <Avatar
                                        size={35}
                                        src={avatar}
                                        icon={<FaUserGraduate size={15} className="text-color-500"/>}
                                        className="flex flex-center background-200"
                                    />
                                    <div className="flex flex-col flex-1">
                                        <span className="font-bold text-sm text-color-000 leading-snug">
                                            {renderIf(
                                                patron_saint_name,
                                                <span
                                                    className="mr-1 font-medium text-xs text-color-100 italic 111-111">
                                                    {getAliasName(o, 'patron_saint')}
                                                </span>
                                            )}
                                            {fullname}
                                        </span>
                                        <div className="text-color-500 text-2xs italic">
                                            <span className="whitespace-no-wrap">
                                                {isSm ? '#' : `${t('student code')} : `}
                                            </span>
                                            <span
                                                className="font-semibold text-blue-500 hover:text-blue-700 italic cursor-pointer">
                                                {student_idcode}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div className="ml-3 flex flex-col gap-1">
                                    {renderIf(
                                        course_class_students.length > 0,
                                        <div className="space-x-1 text-xs italic">
                                            <GoDotFill size={10} className="text-color-500"/>
                                            <span className="text-color-500 whitespace-no-wrap">
                                                {`${t('learn in the class')} : `}
                                            </span>
                                            {course_class_students.map((e, i) => (
                                                <Link key={i} to={getLinkToDetail}
                                                      className="font-bold text-color-000 no-underline">
                                                    {getTitle(e?.course_class)}
                                                    {i < course_class_students.length - 1 && ', '}
                                                </Link>
                                            ))}
                                        </div>
                                    )}
                                    {renderIf(
                                        registered_subjects.length > 0,
                                        <div className="space-x-1 text-xs italic">
                                            <GoDotFill size={10} className="text-color-500"/>
                                            <span className="text-color-500 whitespace-no-wrap italic">
                                                {`${t('subjects registered')} :`}
                                            </span>
                                            {registered_subjects.map((e, i) => (
                                                <span key={i} className="font-semibold text-color-100">
                                                    <GoDash size={10} className="mr-1 text-color-100"/>
                                                    {getTitle(e)}
                                                    {i < registered_subjects.length - 1 && ', '}
                                                </span>
                                            ))}
                                        </div>
                                    )}
                                </div>
                            </div>
                        )
                    }}
                    handleChange={(e) => {
                        let _students = _.cloneDeep(students);

                        const student = _.find(_students, {id: e.target.id});
                        if (!student) {
                            _students.push({
                                student: e.target,
                                student_name: e.target.value,
                                student_id: e.target.id,
                                id: e.target.id || e.target.value,
                            });
                            handleChange(_students)
                        }
                    }}
                />
            </div>

            {students.map((std, idx) => {
                const {student, student_name} = std ?? {}
                return (
                    <div key={idx} className="py-2 rounded-md custom-item-render custom-render-border relative">
                        {renderIfElse(
                            student,
                            <div className="flex items-center gap-2">
                                <Avatar
                                    size={30}
                                    src={student.avatar}
                                    icon={<FaUserGraduate size={16} className="text-color-500"/>}
                                    className="flex flex-center background-200"
                                />
                                <div className="flex flex-col flex-1">
                                    <Link to={getLinkToDetail(student)}
                                          className="font-bold text-color-000 no-underline leading-snug">
                                        {student?.prefix_title || student?.patron_saint_name || ''} {getTitle(student)}
                                    </Link>
                                    <ItemInformation label="student code" value={_.get(student, 'student_idcode')}
                                                     className="text-2xs italic"/>
                                </div>
                            </div>,
                            <div className="font-bold text-color-000">
                                {student_name}
                            </div>
                        )}
                        <BiTrash
                            onClick={() => {
                                let _students = _.cloneDeep(students);
                                showDeleteConfirmDialog({
                                    translate: t,
                                    title: 'delete student',
                                    message: 'are you sure you want to delete this student',
                                    onOk: () => {
                                        _.remove(_students, {id: student?.id});
                                        handleChange(_students)
                                    },
                                })
                            }}
                            className="absolute top-5 right-5 contextIcon text-primary-200 hover:text-primary cursor-pointer"
                        />
                    </div>
                )
            })}
        </div>
    )
}

const formSchema = {
    student: {
        title: 'student',
        children: [
            {
                name: 'student',
                component: mapProps(({name, value, form, onChange}) => {
                    const {owner_id, owner_type} = form?.values ?? {}
                    return {
                        name,
                        value,
                        onChange,
                        owner_id,
                        owner_type,
                    }
                })(StudentSelector),
            },
        ],
    },
    course_class: {
        // title: 'transfer to class',
        children: [
            {
                name: 'course_class',
                component: mapProps(({name, value, form, onChange}) => {
                    const {course_id, student_id} = form?.values ?? {}
                    return {
                        name,
                        value,
                        onChange,
                        course_id,
                        customConfigs: {
                            apiInfo: course_getCourseClassesAvailForStudent_Api,
                            query: bindQueryParams([{student_id}, {id: course_id}]),
                        },
                        placeholder: 'choose classes',
                    }
                })(CourseClassSelector),
            },
        ],
    },
    notes: {
        title: 'notes',
        children: [
            {
                name: 'notes',
                component: createControlledFormField({
                    rows: 3,
                    className: 'w-full',
                    placeholder: 'notes',
                    Component: Input.TextArea,
                }),
            },
        ],
    },
    student_role: {
        title: 'student role',
        children: [
            {
                name: 'role_code',
                component: compose(
                    withTranslate,
                    mapProps(({name, translate, onChange, value}) => ({
                        name,
                        allowClear: true,
                        className: 'w-full',
                        value: value || undefined,
                        onChange: (value) => {
                            onChange(createSelectValue('role_code', value))
                        },
                        placeholder: translate('---Choose One---'),
                        options: ['student', 'student_leader'].map((e) => ({
                            value: e,
                            label: `${translate('role')} ${translate(e)}`,
                        })),
                    })),
                    pure
                )(SelectWidget),
            }
        ],
    },
    sub_class_name: {
        title: 'subclass title',
        children: [
            {
                name: 'sub_class_name',
                component: ({name, value, onChange, form}) => {
                    const values = _.get(form, 'values', {})
                    const owner = _.get(values, 'course_class.owner', {})
                    return (
                        <Translate>
                            {(t) => (
                                <LookupField
                                    createIfNotExists={true}
                                    defaultValue={
                                        values?.sub_class_name
                                    }
                                    apiPath={`/lookup/${getType(owner)}/${getId(owner)}/field/sub_class_name/gets`}
                                    name={name}
                                    placeholder={t('choose or create subclass title')}
                                    handleChange={(e) => {
                                        onChange(
                                            createValue('sub_class_name', e.target.value)
                                        )
                                    }}
                                />
                            )}
                        </Translate>
                    )
                },
            },
        ],
    },
    information_group_header: {
        children: [
            {
                component: () => <HeaderGroupItem title="manager information"/>,
            },
        ],
    },
    metadata: {
        children: [
            {
                name: 'metadata',
                component: ({name, value, onChange}) => (
                    <DynamicFieldsUtilization
                        name={name}
                        value={value}
                        className="w-full"
                        onChange={(value) => {
                            onChange(createValue(name, value ?? null))
                        }}
                    />
                ),
            },
        ],
    },
    diocese_location: {
        inline: true,
        className: 'grid grid-cols-2 gap-3',
        children: [
            {
                label: 'belong to parish',
                name: 'parish',
                component: ({name, value, onChange, form, ...restForm}) => {
                    return (
                        <Translate>
                            {(t) => (
                                <LookupField
                                    title={t('choose parish')}
                                    createIfNotExists={true}
                                    defaultValue={form?.values?.parish_name}
                                    selectedOption={form?.values?.parish}
                                    placeholder={t('click to select / create')}
                                    apiPath={`/lookup/parish/get-by-types`}
                                    name={name}
                                    OptionWrapper={({children, ...props}) =>
                                        <div
                                            className="flex items-center gap-2 border border-color-50 hover:shadow-md rounded-lg relative" {...props}>
                                            {children}
                                        </div>
                                    }
                                    renderOption={(o, i) => {
                                        const {fullname, diocese_fullname, location_address} = o ?? {}
                                        return (
                                            <div key={i} className="flex items-center flex-1 gap-3">
                                                <Avatar
                                                    size={50}
                                                    src={o.avatar}
                                                    className="flex flex-center background-200 rounded-l-lg rounded-r-0"
                                                    icon={<MdChurch size={20} style={{color: '#dddddd'}}/>}
                                                />
                                                <div className="py-2 md:py-0 flex flex-col flex-1 gap-1">
                                                    <div className="space-x-1 leading-snug">
                                          <span className="font-bold text-sm text-color-000">
                                            {fullname}
                                          </span>
                                                        <span
                                                            className="font-medium text-xs text-blue-500 italic leading-snug">
                                            {`( ${diocese_fullname} )`}
                                          </span>
                                                    </div>
                                                    {renderIf(
                                                        location_address,
                                                        <div className="flex items-center gap-x-1">
                                                            <RiMapPinFill size={11} className="text-color-400"/>
                                                            <span
                                                                className="flex-1 max-lines-1 text-xs text-color-400 italic leading-snug">
                                                {location_address}
                                              </span>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        )
                                    }}
                                    handleChange={(e) => {
                                        form.setValues({
                                            ...form.values,
                                            parish: e.target,
                                            parish_name: e.target.value,
                                            parish_id: e.target.id,
                                            diocese: e.target.diocese,
                                            diocese_name: e.target?.diocese?.name,
                                            diocese_id: e.target?.diocese?.id
                                        });
                                    }}
                                />
                            )}
                        </Translate>
                    )
                },
            },
            {
                label: 'diocese',
                component: ({name, value, onChange, form, ...restForm}) => {
                    return (
                        <Input disabled={true} value={_.get(form?.values?.diocese, 'fullname')}/>
                    )
                },
            },
        ],
    },
    students_selection: {
        title: 'students',
        children: [
            {
                name: 'students',
                component: createControlledFormField({
                    className: 'w-full',
                    Component: StudentInCourseSelection,
                    withForm: ({...props}) => ({form: {...props}}),
                    withProps: ({name, value, onChange, ...props}) => {
                        return ({
                            defaultValue: value,
                            handleChange: (_value) => {
                                onChange(createValue(name, _value))
                            },
                            ...props
                        })
                    },
                    withValues: ({resetKey, course, course_class}) => ({
                        resetKey,
                        course, course_class
                    }),
                }),
            },
        ],
    },
}


export const CourseClassStudentAssignmentModal = ({
                                                      course = {},
                                                      onSubmit = NullAsDefault,
                                                  }) => {
    const t = useTranslate();
    const {item: courseClass} = useContext(CourseClassContext)
    const {class_subjects = []} = courseClass || {}

    const initialValues = useMemo(
        () => ({
            role_code: "student",
            students: [],
            course,
            course_class: courseClass,
            subject_ids: class_subjects.map(e => {
                return e?.subject?.id;
            })
        }),
        [course, courseClass]
    );


    const validate = (values) => {
        let errors = {}

        return errors
    }

    return (
        <Formik
            validate={validate}
            validateOnMount={true}
            validateOnChange={true}
            enableReinitialize={true}
            initialValues={initialValues}
            onSubmit={(values) => {
                const {students, sub_class_name, subject_ids} = values ?? {}
                const ids = students.map(item => item.student_id);
                onSubmit({
                    sub_class_name,
                    student_ids: ids,
                    subject_ids
                })
            }}>
            <ActionModalWrapper action={<FormActionBar submitText="add"/>}>
                <div className="text-color-400 italic">
                    {`* ${t('assign student for class description')}`}
                </div>
                <Pure>
                    <FieldsFactory
                        formSchema={[
                            formSchema.student_role,
                            formSchema.sub_class_name,
                            formSchema.students_selection,
                        ]}
                    />

                    {renderIf(
                        class_subjects.length > 0,
                        <FormikConsumer>
                            {({values, errors, handleChange}) => (
                                <div className="flex flex-col gap-2">
                                    <HeaderWithIconLine
                                        icon={<BsInfoCircleFill size={14} className="text-color-500 mr-1"/>}
                                        title="choose subject"
                                        className="text-base text-color-300"
                                    />
                                    <FieldDecorator key="subject_ids" errors={errors["subject_ids"]}>
                                        <Checkbox.Group
                                            className="ml-2 grid grid-cols-2 gap-2"
                                            name="subject_ids"
                                            options={class_subjects.map(e => {
                                                return {value: e?.subject?.id, label: e?.subject?.title}
                                            })}
                                            defaultValue={values.subject_ids}
                                            onChange={e => {
                                                handleChange(createValue('subject_ids', e))
                                            }}
                                        />
                                    </FieldDecorator>
                                </div>
                            )}
                        </FormikConsumer>
                    )}
                </Pure>
            </ActionModalWrapper>
        </Formik>
    )
}

export const CourseClassStudentUpdateModal = ({
                                                  course: inputCourse,
                                                  courseClassStudent,
                                                  onSubmit = NullAsDefault
                                              }) => {
    const t = useTranslate()
    const [current, setCurrent] = useState('overview');

    const {course: courseClassStudentCourse, course_class} = courseClassStudent || {};
    const course = inputCourse || courseClassStudentCourse;

    const initialValues = useMemo(() => ({
            ...courseClassStudent,
            course,
            course_class,
            subject_ids: _.get(courseClassStudent, 'registered_subjects', []).map(e => {
                return e?.id;
            })
        }),
        [courseClassStudent]
    );

    const validate = (values) => {
        let errors = {}

        return errors
    }

    return (
        <Formik
            validate={validate}
            validateOnMount={true}
            validateOnChange={true}
            enableReinitialize={true}
            initialValues={initialValues}
            onSubmit={({metadata, ...values}) => {
                const changes = shallowDiff(values, initialValues)
                onSubmit(
                    _.omitBy(
                        {
                            ...(changes ?? {})
                        },
                        _.isUndefined
                    )
                )
            }}>
            <ActionModalWrapper
                tab={current}
                action={<FormActionBar submitText="save"/>}
                onTabChange={(key) => {
                    setCurrent(key)
                }}
                tabs={[
                    {
                        key: 'overview',
                        label: 'overview',
                        component: () => (
                            <StudentInformationFull {...courseClassStudent}/>
                        )
                    },
                    {
                        key: 'additional_info',
                        label: 'manage class information',
                        component: () => (
                            <React.Fragment>
                                <div className="text-color-400 italic">
                                    {`* ${t('update student information in the class description')}`}
                                </div>
                                <Pure>
                                    <FieldsFactory
                                        formSchema={[
                                            formSchema.student_role,
                                            formSchema.sub_class_name,
                                        ]}
                                    />
                                </Pure>

                                <FormikConsumer>
                                    {({values, errors, handleChange}) => {
                                        return (
                                            <div className="flex flex-col gap-2 pt-3">
                                                <ListHeaderLineAndDes
                                                    renderTitle={() => (
                                                        <div className="flex items-start gap-1">
                                                            <BsCaretRightFill size={15}
                                                                              className="text-color-500 mr-1"/>
                                                            <div
                                                                className="flex-1 font-bold text-base text-color-300 uppercase tracking-wide leading-tight">
                                                                {t('subjects')}
                                                            </div>
                                                        </div>
                                                    )}
                                                    description="with subject"

                                                />
                                                <FieldDecorator
                                                    key="subject_ids"
                                                    errors={errors["subject_ids"]}
                                                >
                                                    <Checkbox.Group
                                                        className="grid grid-cols-2 gap-2"
                                                        name="subject_ids"
                                                        options={_.get(course, 'subjects', []).map(e => {
                                                            return {
                                                                value: e?.subject?.id,
                                                                label: e?.subject?.title
                                                            }
                                                        })}
                                                        defaultValue={values.subject_ids}
                                                        onChange={e => {
                                                            handleChange(createValue('subject_ids', e))
                                                        }}
                                                    />
                                                </FieldDecorator>
                                            </div>
                                        )
                                    }}
                                </FormikConsumer>
                            </React.Fragment>
                        ),
                    },
                ]}>
            </ActionModalWrapper>
        </Formik>
    )

}

export const CourseClassStudentTransferModal = ({
                                                    course_id,
                                                    owner_id,
                                                    owner_type,
                                                    onSubmit = NullAsDefault,
                                                    course_class_student,
                                                }) => {
    const t = useTranslate()

    const student_id = getId(course_class_student?.student)

    const initialValues = useMemo(
        () => ({
            course_id,
            student_id,
            course_class: undefined,
        }),
        [course_id, student_id, course_class_student]
    )

    const validate = (values) => {
        let errors = {}

        const {course_class} = values ?? {}

        if (!getId(course_class)) {
            errors.course_class = t('required field')
        }

        return errors
    }

    return (
        <Formik
            validate={validate}
            validateOnMount={true}
            validateOnChange={true}
            enableReinitialize={true}
            initialValues={initialValues}
            onSubmit={(values) => {
                const {course_class} = values ?? {}
                onSubmit({
                    course_class_id: getId(course_class),
                })
            }}>
            <ActionModalWrapper action={<FormActionBar submitText="transfer"/>}>
                <StudentInformationCompact student={course_class_student?.student}/>
                <div className="flex flex-col gap-2 mt-2">
                    <ListHeaderLineAndDes
                        renderTitle={() => (
                            <div className="flex items-center gap-2">
                                <GiCardExchange size={14} className="text-color-500"/>
                                <span className="font-semibold text-sm text-color-300 uppercase tracking-wider">
                                    {t('transfer to class')}
                                </span>
                            </div>
                        )}
                        description="student transfer description"
                    />
                    <div className="ml-2">
                        <FieldsFactory formSchema={[formSchema.course_class]}/>
                    </div>
                </div>
            </ActionModalWrapper>
        </Formik>
    )
}

export const CourseClassStudentList = ({
                                           item,
                                           header = null,
                                           controls = pagerControls,
                                           renderFooter = renderSelf,
                                           container_type = AppEntities.COURSE,
                                       }) => {
    const t = useTranslate()

    const [action, setAction] = useState({
        type: undefined,
        value: undefined,
    })
    const {item: courseClass = item} = useContext(CourseClassContext);

    const course = courseClass?.course

    const [refreshToken, setRefreshToken] = useState()

    const {owner} = courseClass ?? {}

    const course_class_id = getId(courseClass)

    const [owner_id, owner_type] = [getId(owner), getType(owner)]

    const {keyword, component: search_widget} = controls?.search ?? {}
    const [sub_class_name, setSubClassName] = useState()
    const [filterSubject, setFilterSubject] = useState(false)

    const apiInfo = course_getCourseClassStudents_Api

    const refreshKey = useMemo(
        () =>
            [
                apiInfo?.path.replace(':id', course_class_id),
                JSON.stringify(keyword),
                sub_class_name,
                filterSubject?.subject?.id,
                refreshToken,
            ].join(','),
        [keyword, refreshToken, sub_class_name, course_class_id, filterSubject]
    )

    const onError = notifyOnError(t)

    const onCancel = () => {
        setAction({})
    }

    const reload = () => {
        setRefreshToken(Date.now())
        onCancel()
    }

    const {handleAsyncAction: onAssignMulti} = useAsyncAction({
        apiInfo: course_assignMultiStudentToCourseClass_Api,
        onError,
        onSuccess: () => {
            successNotify(NotificationActionTypes.UPDATE, t)
            reload()
        },
    })

    const {handleAsyncAction: onAssign} = useAsyncAction({
        apiInfo: course_assignStudentToCourseClass_Api,
        onError,
        onSuccess: () => {
            successNotify(NotificationActionTypes.UPDATE, t)
            reload()
        },
    })

    const {handleAsyncAction: onUpdate} = useAsyncAction({
        apiInfo: course_editStudentFromCourseClass_Api,
        onError,
        onSuccess: () => {
            successNotify(NotificationActionTypes.INFORMATION, t)
            reload()
        },
    })

    const {handleAsyncAction: onRevoke} = useAsyncAction({
        apiInfo: course_revokeStudentFromCourseClass_Api,
        onError,
        onSuccess: () => {
            successNotify(NotificationActionTypes.INFORMATION, t)
            reload()
        },
    })

    const {handleAsyncAction: onAwardMedal} = useAsyncAction({
        apiInfo: medal_addMedalAward_Api,
        onError,
        onSuccess: () => {
            successNotify(NotificationActionTypes.INFORMATION, t)
            reload()
        },
    })

    const {handleAsyncAction: onTransfer} = useAsyncAction({
        apiInfo: course_transferStudentFromCourseClassTo_Api,
        onError,
        onSuccess: () => {
            successNotify(NotificationActionTypes.INFORMATION, t)
            reload()
        },
    })

    const handleAction = (action, params) => {
        const id = params?.id
        switch (action) {
            case StudentActionTypes.STUDENT_DETAIL:
            case StudentActionTypes.STUDENT_MOVE:
            case StudentActionTypes.STUDENT_ASSIGN:
            case StudentActionTypes.STUDENT_IN_CLASS_UPDATE:
            case StudentActionTypes.STUDENT_SUBJECT_SCORE_SUMMARY:
            case StudentActionTypes.STUDENT_ATTENDANCE_TRACKING:
                setAction({type: action, value: params})
                break
            case StudentActionTypes.STUDENT_REVOKE:
                if (id) {
                    showDeleteConfirmDialog({
                        translate: t,
                        title: 'revoke student',
                        message: 'are you sure you want to revoke this student',
                        onOk: () => {
                            onRevoke({}, {id})
                        },
                    })
                }
                break
            default:
                break
        }
    }

    const renderContextMenu = useCallback(
        (item) =>
            createContextMenu(
                [
                    {
                        icon: <RiSearchEyeLine size={14} className="text-color-400"/>,
                        label: 'detail',
                        key: StudentActionTypes.STUDENT_DETAIL,
                    },
                    {
                        icon: <BiSolidEdit size={14} className="text-blue-500"/>,
                        label: 'update information',
                        key: StudentActionTypes.STUDENT_IN_CLASS_UPDATE,
                    },
                    {
                        icon: <AiOutlineAudit size={14} className="text-green-600"/>,
                        label: 'attendance tracking',
                        key: StudentActionTypes.STUDENT_ATTENDANCE_TRACKING,
                    },
                    {
                        icon: <RiUserShared2Line size={14} className="text-blue-500"/>,
                        label: 'move student',
                        key: StudentActionTypes.STUDENT_MOVE,
                    },
                    {
                        icon: <BiTrash size={14} className="text-primary-300"/>,
                        label: 'delete',
                        key: StudentActionTypes.STUDENT_REVOKE,
                    },
                ].filter((e) => item),
                (key) => {
                    handleAction(key, item)
                }
            ),
        [course]
    )

    const modal = useMemo(() => {
        let title
        let Content = NullAsDefault
        let params = {title: null}
        let modal_params = {}
        let Wrapper = ({children}) => children({item: {}})

        switch (action?.type) {
            case StudentActionTypes.STUDENT_ATTENDANCE_TRACKING:
                if (container_type === AppEntities.COURSE_CLASS) {
                    title = (
                        <div className="text-center font-bold text-color-000 uppercase tracking-wide">
                            {t('attendance tracking')}
                        </div>
                    )
                    params = {
                        onCancel,
                        courseClass: item,
                        student: action?.value?.student,
                    }
                    modal_params = {
                        width: 640,
                    }
                    Content = CourseClassStudentAttendantsForm
                    break
                } else {
                    return (
                        <FullSideModalLayout
                            right={true}
                            onCancel={onCancel}
                            title={createModalTitle('attendance tracking')}>
                            <CourseClassStudentAttendantsForm
                                courseClass={item}
                                student={action?.value?.student}
                            />
                        </FullSideModalLayout>
                    )
                }

            case StudentActionTypes.STUDENT_IN_CLASS_UPDATE:
                title = (
                    <div className="text-center font-bold text-color-000 uppercase tracking-wide">
                        {t('update student information in the class')}
                    </div>
                )
                params = {
                    courseClassStudent: action?.value,
                    course: courseClass?.course,
                    source: 'CourseClassStudentForm',
                    onCancel,
                    onSubmit: (values) => {
                        onUpdate(values, {
                            id: action?.value?.id,
                        })
                    },
                }
                modal_params = {
                    width: 768,
                }
                Content = CourseClassStudentUpdateModal
                break
            case StudentActionTypes.STUDENT_ASSIGN:
                title = (
                    <div className="text-center font-bold text-color-000 uppercase tracking-wide">
                        {t('assign course class student')}
                    </div>
                )
                params = {
                    course: item?.course,
                    courseClass: item,
                    onCancel,
                    onSubmit: (values) => {
                        const {...rest} = values ?? {}
                        onAssignMulti(
                            {...rest},
                            {
                                course_class_id,
                            }
                        )
                    },
                }
                modal_params = {
                    width: 640,
                }
                Content = CourseClassStudentAssignmentModal
                break
            case StudentActionTypes.STUDENT_MOVE:
                const {course, ...course_class_student} = action?.value ?? {}
                const course_id = getId(course)
                const course_class_student_id = getId(course_class_student)
                title = (
                    <div className="text-center font-bold text-color-000 uppercase tracking-wide">
                        {t('move student')}
                    </div>
                )
                params = {
                    course_class_student,
                    course_id,
                    onCancel,
                    onSubmit: (values) => {
                        const {course_class_id} = values ?? {}
                        onTransfer(
                            {},
                            {
                                course_class_id,
                                course_class_student_id,
                            }
                        )
                    },
                }
                modal_params = {
                    width: 640,
                }
                Content = CourseClassStudentTransferModal
                break
            case StudentActionTypes.STUDENT_DETAIL:
                title = (
                    <div className="text-center font-bold text-color-000 uppercase tracking-wide">
                        {t('student information')}
                    </div>
                )
                params = {
                    item: action?.value
                }
                modal_params = {
                    width: 640,
                }
                Content = () => {
                    return (
                        <div className="flex flex-col gap-6 mb-6">
                            <div className="flex flex-col gap-3">
                                <HeaderWithIconLine
                                    renderTitle={() => (
                                        <span className="font-semibold text-sm text-color-300 uppercase tracking-wider">
                                            {t('registered subjects')}
                                        </span>
                                    )}
                                />
                                {renderIfElse(
                                    _.get(action?.value, 'registered_subjects.length') > 0,
                                    <div className="ml-2 grid grid-cols-1 md:grid-cols-2 gap-x-2 gap-y-1">
                                        {_.get(action?.value, 'registered_subjects', []).map((e, i) => (
                                            <span key={i} className="flex items-center gap-x-2">
                                            <GiPlainCircle size={7} className="text-blue-200"/>
                                            <span className="font-semibold text-blue-600 text-sm italic leading-snug">
                                                {getTitle(e)}
                                            </span>
                                        </span>
                                        ))}
                                    </div>,
                                    <EmptyHolder/>
                                )}

                            </div>
                            <StudentInformationFull {...action?.value}/>
                        </div>
                    )
                }
                break
            default:
                break
        }

        return (
            <Modal
                footer={null}
                title={title}
                onCancel={onCancel}
                destroyOnHidden={true}
                open={action?.type}
                className="custom-modal"
                {...modal_params}>
                <Wrapper>
                    {({item, isLoading}) => {

                        if (!!isLoading) {
                            return <LoadingBlock/>
                        }
                        return (
                            <Content
                                {...params}
                                {...{owner_id, owner_type}}
                            />
                        )
                    }}
                </Wrapper>
            </Modal>
        )
    }, [action, owner_id, owner_type, course_class_id])

    const {
        class_subjects = [],
        coordinators = [],
        sub_class_names = [],
        number_of_students,
        description,
        course_class_idcode,
        title,
    } = courseClass ?? {}

    return renderIf(
        courseClass,
        <ActionModalWrapper className="flex-1">
            {header}
            <div className="flex flex-col gap-1 mb-3">
                <div className="font-bold text-base text-gray-700 tracking-wide uppercase">
                    {t('class information')}
                </div>
                <div className="ml-2 flex flex-col gap-1">
                    <ItemInformation
                        showIcon={true}
                        label="course class idcode"
                        value={course_class_idcode}
                        className="text-xs italic"
                    />
                    <ItemInformation
                        showIcon={true}
                        label="belong to the course"
                        value={getTitle(course)}
                        className="text-xs italic"
                    />
                    {renderIf(
                        coordinators.length > 0,
                        <span className="space-x-1 text-xs italic">
                            <GoDotFill size={10} className="text-color-400"/>
                            <span className="text-color-500">{`${t('class coordinator')} : `}</span>
                            {coordinators.map((e, i) => (
                                <span key={i} className="font-semibold text-color-100">
                                    {e?.teacher_name} {i < coordinators.length - 1 && ', '}
                                </span>
                            ))}
                        </span>
                    )}
                    {renderIf(
                        number_of_students > 0,
                        <ItemInformation
                            showIcon={true}
                            label="number of student"
                            value={`${number_of_students} ${t('students')}`}
                            className="text-xs italic"
                        />
                    )}
                    {renderIf(
                        class_subjects.length > 0,
                        <span className="space-x-1 text-xs italic">
                            <GoDotFill size={10} className="text-color-400"/>
                            <span className="text-color-500">{`${t('subjects')} : `}</span>
                            {class_subjects.map((e, i) => (
                                <span key={i} className="font-semibold text-color-100">
                                    {e?.subject?.title} {i < class_subjects.length - 1 && ', '}
                                </span>
                            ))}
                        </span>
                    )}
                </div>
            </div>
            <div className="flex flex-col space-y-3 flex-1">
                <HeaderWithIconLine
                    line={false}
                    className="justify-between"
                    renderTitle={() => (
                        <div className="font-bold text-base text-gray-700 tracking-wide uppercase">
                            {t('list students of class')}
                        </div>
                    )}
                    extra={
                        <Button
                            size="small"
                            color="primary" variant="filled"
                            className="flex flex-center button-rounded-md no-border font-medium text-xs px-3"
                            onClick={() => {
                                handleAction(StudentActionTypes.STUDENT_ASSIGN)
                            }}>
                            {t('add student')}
                        </Button>
                    }
                />
                {search_widget}
                <div className="flex flex-col gap-2">
                    {renderIf(
                        sub_class_names.length > 0,
                        <div className="flex gap-2">
                            <span style={{marginTop: 2}}
                                  className="text-xs text-color-400 italic whitespace-no-wrap leading-snug 111-111">
                              {`${t('subclass title')} : `}
                            </span>
                            <SubClassTags
                                items={_.get(item, 'sub_class_names', [])}
                                selected={sub_class_name}
                                setSelected={setSubClassName}
                            />
                        </div>
                    )}
                    {renderIf(
                        class_subjects.length > 0,
                        <div className="flex gap-2">
                            <span style={{marginTop: 2}}
                                  className="text-xs text-color-400 italic whitespace-no-wrap leading-snug 111-111">
                              {`${t('subjects')} : `}
                            </span>
                            <div className="flex flex-wrap gap-y-1 gap-x-2">
                                {class_subjects.map((e, i) => (
                                    <span
                                        key={i}
                                        style={{padding: '0px 8px', height: 24, borderRadius: 4}}
                                        onClick={() => {
                                            if (filterSubject === e) {
                                                setFilterSubject(null)
                                            } else {
                                                setFilterSubject(e)
                                            }
                                        }}
                                        className={classNames(
                                            "flex flex-center cursor-pointer rounded-md font-semibold text-xs",
                                            filterSubject === e ?
                                                "bg-blue-100 hover:bg-blue-200 text-blue-600" :
                                                "background-100 hover:bg-blue-50 text-color-300 hover:text-blue-500"
                                        )}>
                                    {e?.subject?.title}
                                </span>
                                ))}
                            </div>
                        </div>
                    )}
                </div>
                <EntityList
                    cacheId={refreshKey}
                    key={refreshKey}
                    apiInfo={apiInfo}
                    values={{keyword, sub_class_name, subject_id: filterSubject?.subject?.id}}
                    RenderEntity={React.Fragment}
                    PaginationMeta={NoneStickyMeta}
                    query={bindQueryParam({id: course_class_id})}
                    renderItem={renderCourseClassStudent({renderContextMenu})}
                    renderWrap={(child) => (
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                            {child}
                        </div>
                    )}
                />
            </div>
            {renderFooter(null)}
            {modal}
        </ActionModalWrapper>
    )
}


